import { createSlice } from '@reduxjs/toolkit';

const resetState = {
  moduleConfig: {},
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    ...resetState,
  },
  reducers: {
    setModuleConfig: (reduxState, { payload = {} }) => {
      reduxState.moduleConfig = payload;
    },
    resetSettingsSlice: (reduxState) => {
      Object.assign(reduxState, resetState);
    },    
  },
});

export const { setModuleConfig, resetSettingsSlice } = settingsSlice.actions;

export { resetState as settingsResetState };

export default settingsSlice.reducer;
